@if (resolvedImage(); as img) {
    <img [src]="img.image.url" [alt]="img.title" data-cy="image" />
}
<a [siriusLink]="resolvedLink()" class="sir-card__link" (linkSelect)="onClick()" data-cy="link">
    @if (resolvedTitle(); as titleText) {
        <h3
            data-cy="title"
            [class.sir-text-style-paragraph-m-bold]="!resolvedImage()"
            [class.sir-text-style-paragraph-m-default]="!!resolvedImage()">{{ titleText }}</h3>
    } @else {
        <span class="sir-card__sr-only-label">{{ resolvedLink().title }}</span>
    }
</a>
